import { useContext } from "react";
import { feedbackContext } from "./feedbackContext";

export const useFeedback = () => {
  return useContext(feedbackContext);
}
